import { RaptorJobs } from './raptor-jobs'
import parse from 'csv-parse'

export class PrMJobs extends RaptorJobs {
  constructor (Vue, options) {
    super()
    this._app = Vue
  }

  authAndCall (call) {
    return new Promise((resolve, reject) => {
      if (typeof gapi === 'undefined') {
        this._app.$auth.onChange((state) => {
          if (state) {
            this[call]((error, response) => {
              if (error) {
                reject(error)
              } else {
                resolve(response)
              }
            })
          }
        })
      } else {
        this[call]((error, response) => {
          if (error) {
            reject(error)
          } else {
            resolve(response)
          }
        })
      }
    })
  }

  getClients () {
    return this.authAndCall('_getClients')
  }

  getPostsFiles () {
    return this.authAndCall('_getPostsFiles')
  }

  getJobs () {
    return this._batchJobs(['arn:aws:batch:us-east-1:976741133712:job-queue/raptorSchemaUpdates']).then((jobs) => {
      return jobs.filter((job) => job.jobName.split('-').shift() === ('raptorProductionPresenceManagementReport'))
    })
  }

  _getClients (callback) {
    gapi.client.load('drive', 'v3', () => {
      gapi.client.drive.files.export({
        'fileId': '1UT2ZxyHbNI3Wtzp1qVocvURTEYLUdRmTRV5saOoMB_k',
        'mimeType': 'text/csv'
      }).then((response) => {
        parse(response.body, {
          columns: true,
          trim: true
        }, callback)
      }).catch((error) => callback(error))
    })
  }

  _getPostsFiles (callback) {
    gapi.client.load('drive', 'v3', () => {
      gapi.client.drive.files.list({
        'fields': 'files(name)',
        'q': '(\'1JS5cvooTPcpBoXA9WyEhHpS3mL-sBZet\' in parents)'
      }).then((response) => {
        callback(null, response.result.files)
      }).catch((error) => callback(error))
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/prm-jobs.js